import React, { useState, useEffect } from 'react';
import { createPackage, updatePackage } from '../../api/api';
import { Package } from '../../types';

interface Props {
  initialData?: Package | null;
  onSuccess: (newPackage: Package) => void;
}

const PackageForm: React.FC<Props> = ({ initialData, onSuccess }) => {
  const isEditing = !!initialData;

  // State
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Effect để điền dữ liệu vào form khi ở chế độ Edit
  useEffect(() => {
    if (isEditing && initialData) {
      setName(initialData.name);
      setDescription(initialData.description);
    } else {
      setName('');
      setDescription('');
    }
  }, [initialData, isEditing]);

  // Handler
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const packageData: Omit<Package, 'id'> = {
      name,
      description,
      image: initialData?.image || '',
    };

    try {
      if (isEditing && initialData) {
        await updatePackage(initialData.id, packageData);
        onSuccess(initialData);
      } else {
        const newPackage = await createPackage(packageData);
        onSuccess(newPackage);
      }
    } catch (err) {
      setError('Failed to save package.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="creation-form">
      <input type="text" placeholder="Package Name" value={name} onChange={(e) => setName(e.target.value)} required disabled={isLoading} />
      <textarea placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} rows={4} required disabled={isLoading}></textarea>
      {error && <p className="error-message">{error}</p>}
      <button type="submit" className="btn" disabled={isLoading}>
        {isLoading ? 'Saving...' : (isEditing ? 'Save Changes' : 'Create Package')}
      </button>
    </form>
  );
};

export default PackageForm;